import type { SeoSegments } from '@handyhand/i18n';

import { HowTo } from '@models/guides/howToGuide.model';
import { Vertical } from '@models/vertical/vertical.model';
import { PriceGuide } from '@models/guides/priceGuide.model';
import { Blog } from '@models/blog.model';
import { Tip } from '@models/guides/tips.model';
import { buildContentPath, contentSlug } from '@helpers/contentPath';

/** URL of a hub-page card. Content links ignore `subSubCategory` (see `buildContentPath`). */
export function generateEntityUrl(
  seoSegments: SeoSegments,
  entity: HowTo | Vertical | PriceGuide | Blog | Tip,
  headCategory?: string,
  subCategory?: string | null,
  subSubCategory?: string | null,
): string {
  const slug = contentSlug(entity as { slug?: string; newSlug?: string });
  const content = (suffix: string): string =>
    buildContentPath({ categories: [headCategory, subCategory], slug, suffix });

  if ('mostRelevantPriceGuide' in entity) {
    return content(seoSegments.suffix.aiPriceGuide);
  }
  if ('uniqueId' in entity) {
    if (!headCategory || headCategory === slug.toLowerCase()) {
      return `/${slug}/${seoSegments.suffix.serviceVertical}`;
    }
    return `/${headCategory}/${slug}/${seoSegments.suffix.serviceVertical}`;
  }
  if ('price_guide' in entity || entity instanceof PriceGuide) {
    return content(seoSegments.suffix.priceGuide);
  }
  if ('tips' in entity) {
    return content(seoSegments.suffix.tips);
  }
  if ('guide' in entity || entity instanceof HowTo) {
    return content(seoSegments.suffix.guide);
  }
  if ('blog' in entity || entity instanceof Blog) {
    return content(seoSegments.suffix.article);
  }

  const hubChain = [headCategory, subCategory, subSubCategory].filter(Boolean);
  return `/${[...hubChain, slug, seoSegments.suffix.hubIndex].join('/')}`;
}
